module.exports = __webpack_public_path__ + "static/media/SJE089_02.710abe85.jpg";